import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@gasbuddy/react-components';
import styles from './styles.css';
import ImageWithText from '../image-with-text';
import { ElementPosition } from '../../utils/prop-types/common-types';

const ToggleIcon = ({
  canToggle,
  isActive,
  name,
  imageName,
  handleOnClick,
  imagePath,
  value,
  faIcon,
  isVertical,
  showHasNoIcon,
  iconWidth,
  iconHeight,
  imagePosition,
}) => {
  let imgSrc = `${imagePath}${(!canToggle || (canToggle && isActive) ? 'selected' : 'default')}/${imageName}.png`;

  if (showHasNoIcon) {
    imgSrc = `${imagePath}selected/${isActive ? 'has_' : 'has_no_'}${imageName}.png`;
  }
  let faClassName = `${styles.faIcon}`;
  if (canToggle) {
    if (isActive) {
      faClassName = `${styles.activeIcon} ${faClassName}`;
    } else {
      faClassName = `${styles.inactiveIcon} ${faClassName}`;
    }
  }

  return (
    <div
      className={`${styles.iconRow} ${canToggle ? `${styles.toggleIconRow}` : ''} ${isVertical ? `${styles.toggleIconColumn}` : ''}`}
      onClick={e => !!handleOnClick && handleOnClick(e)}
      style={{ styles: `${canToggle ? 'cursor' : 'default'}` }}
      role="checkbox"
      tabIndex="0"
      onKeyPress={undefined}
      aria-checked={isActive}
      data-value={value}
    >
      {canToggle
        && (
          <div className={styles.iconCheckbox}>
            <Checkbox checked={isActive} onChange={(e) => { e.preventDefault(); document.activeElement.click(); }} />
          </div>
        )
      }
      <ImageWithText
        text={name}
        imagePosition={imagePosition}
        imageWidth={iconWidth}
        imageHeight={iconHeight}
        imageName={imageName}
        imageSource={imgSrc}
        faClassName={faClassName}
        faIcon={faIcon}
      />
    </div>
  );
};

ToggleIcon.propTypes = {
  canToggle: PropTypes.bool,
  isActive: PropTypes.bool,
  name: PropTypes.string.isRequired,
  handleOnClick: PropTypes.func,
  imageName: PropTypes.string,
  value: PropTypes.string.isRequired,
  imagePath: PropTypes.string, // eslint-disable-next-line react/forbid-prop-types
  faIcon: PropTypes.object,
  isVertical: PropTypes.bool,
  showHasNoIcon: PropTypes.bool,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  imagePosition: ElementPosition,
};

ToggleIcon.defaultProps = {
  canToggle: false,
  isActive: false,
  handleOnClick: undefined,
  imagePath: '/images/stationProfile/',
  imageName: undefined,
  faIcon: undefined,
  isVertical: false,
  showHasNoIcon: false,
  iconWidth: 30,
  iconHeight: 30,
  imagePosition: 'Left',
};

export default ToggleIcon;
